<template>
  <div>
    <NavbarMobileComponent :items="itemsA.concat(itemsB)" />

    <aside class="nav-shell" :class="{ 'nav-collapsed': mini }">
      <div class="nav-mesh" aria-hidden="true"></div>

      <div class="nav-logo">
        <v-img
          class="nav-logo-img"
          :src="imageError ? require('@/assets/img/login.png') : logoSistema"
          :width="mini ? '48px !important' : '132px !important'"
          @error="imageError = true"
          contain
        />
      </div>

      <nav class="nav-content">
        <p v-show="!mini" class="nav-section">Principal</p>
        <ul class="nav-list">
          <li
            v-for="item in itemsA"
            :key="item.id"
            v-show="(permissoes.includes(item.permission_name) || item.permission_name == '') && item.show"
          >
            <router-link
              :to="{ name: item.name }"
              class="nav-item"
              :class="{ 'nav-item-active': isNavActive(item) }"
            >
              <span class="nav-icon"><v-icon>{{ item?.icon }}</v-icon></span>
              <span v-show="!mini" class="nav-text">{{ item?.title }}</span>
            </router-link>
          </li>
        </ul>

        <p v-show="!mini" class="nav-section">Serviços</p>
        <ul class="nav-list">
          <li
            v-for="item in itemsServices"
            :key="item.id"
            v-show="(permissoes.includes(item.permission_name) || item.permission_name == '') && item.show"
          >
            <router-link
              :to="{ name: item.name }"
              class="nav-item"
              :class="{ 'nav-item-active': isNavActive(item) }"
            >
              <span class="nav-icon">
                <v-badge
                  :value="item.name === 'notificacoesIndex' && avisos.naoLidas > 0"
                  :content="avisos.naoLidas"
                  color="error"
                  overlap
                >
                  <v-icon>{{ item?.icon }}</v-icon>
                </v-badge>
              </span>
              <span v-show="!mini" class="nav-text">{{ item?.title }}</span>
            </router-link>
          </li>
        </ul>

        <p v-show="!mini" class="nav-section">Conta</p>
        <ul class="nav-list">
          <li
            v-for="item in itemsAccount"
            :key="item.id"
            v-show="(permissoes.includes(item.permission_name) || item.permission_name == '') && item.show"
          >
            <router-link
              :to="{ name: item.name }"
              class="nav-item"
              :class="{ 'nav-item-active': isNavActive(item) }"
            >
              <span class="nav-icon"><v-icon>{{ item?.icon }}</v-icon></span>
              <span v-show="!mini" class="nav-text">{{ item?.title }}</span>
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="nav-user">
        <div class="nav-user-avatar">
          <img :src="this.$user.profile" alt="" />
        </div>
        <div v-show="!mini" class="nav-user-info">
          <p class="nav-user-name">{{ this.$user.nome }}</p>
          <p class="nav-user-email">{{ this.$user.email }}</p>
        </div>
      </div>

      <button class="nav-toggle" @click="mini = !mini" type="button">
        <v-icon v-show="!mini">mdi-chevron-left</v-icon>
        <v-icon v-show="mini">mdi-chevron-right</v-icon>
      </button>
    </aside>
  </div>
</template>

<script>
import NavbarMobileComponent from '@/components/navbarmobile/NavBarMobileComponent.vue';
import { getContrastColor } from '@/utils/global/tema';
import avisosStore from '@/store/avisos';
import { podeVerAvisos } from '@/utils/avisos/permissoes';

export default {
  name: 'NavBarComponent',

  components: {
    NavbarMobileComponent,
  },

  data() {
    return {
      imageError: false,
      corSistema: this.$vuetify.theme.themes.light.primary,
      logoSistema: ['Construtora', 'construtora'].includes(this.$user?.unidade) ? this.$user.construtora_logo : this.$user.empreendimento_logo,
      colorPrimary: '#FCCF32',
      rota: this.$route.name,
      permissoes: this.$user.permissoes.split(','),
      avisos: avisosStore.state,
      drawer: true,
      mini: false,
      itemsA: [
        { id: 12, title: 'Home', icon: 'mdi-home-outline', name: 'construtoraHome', permission_name: 'painel-web-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 13, title: 'Manuais', icon: 'mdi-book-open-page-variant-outline', name: 'construtoraManuais', permission_name: 'manual-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 14, title: 'Databooks', icon: 'mdi-database-outline', name: 'construtoraDatabooks', permission_name: 'databooks-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 15, title: 'Empreendimentos', icon: 'mdi-office-building-cog', name: 'construtoraEmpreendimentos', permission_name: 'empreendimentos-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 16, title: 'Usuários', icon: 'mdi-account-group', name: 'construtoraCondominos', permission_name: 'condomino-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },

        { id: 0, title: 'Home', icon: 'mdi-home-outline', name: 'home', permission_name: '', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 1, title: 'Manuais', icon: 'mdi-book-open-page-variant-outline', name: 'manuais', permission_name: 'manual-app-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 2, title: 'Projetos / Desenhos Técnicos', icon: 'mdi-folder-multiple-outline', name: 'projetos', permission_name: 'projetos-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 26, title: 'Arq. Garantias', icon: 'mdi-shield-check-outline', name: 'manuaisGarantias', permission_name: 'manual-garantia-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 27, title: 'Arq. Manutenções', icon: 'mdi-cog-outline', name: 'manuaisManutencoes', permission_name: 'manual-manutencao-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 3, title: 'Databooks', icon: 'mdi-database-outline', name: 'databook', permission_name: 'databooks-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 4, title: 'Vídeos', icon: 'mdi-video-outline', name: 'videos', permission_name: 'videos-app-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 5, title: 'Sobre', icon: 'mdi-information-outline', name: 'sobre', permission_name: 'sobre-view', show: false },
        { id: 6, title: 'Localização', icon: 'mdi-map-marker-outline', name: 'localizacao', permission_name: 'localizacao-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
      ],
      itemsB: [
        { id: 17, title: 'Manutenções', icon: 'mdi-calendar-check-outline', name: 'construtoraManutencoes', permission_name: 'manutencao-construtora-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 18, title: 'Relatórios (Man.)', icon: 'mdi-chart-timeline-variant-shimmer', name: 'construtoraManutencoesRelatorio', permission_name: 'manutencao-construtora-view', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 19, title: 'Novo Chamado', icon: 'mdi-check-decagram', name: 'construtoraAssistenciaTecnicaCreate', permission_name: 'garantia-create', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 20, title: 'Assistência Técnica', icon: 'mdi-wrench-outline', name: 'construtoraAssistenciaTecnica', permission_name: 'garantia-list', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 21, title: 'Relatórios (ASTEC)', icon: 'mdi-chart-box-outline', name: 'construtoraRelatoriosIndex', permission_name: 'report-list', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 22, title: 'Categorias', icon: 'mdi-format-list-numbered', name: 'construtoraCategoriasIndex', permission_name: 'categories-list', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 23, title: 'Base de Soluções', icon: 'mdi-clipboard-list-outline', name: 'construtoraBaseSolucoesIndex', permission_name: 'solution-list', show: false },
        // Ver e enviar são independentes: o item aparece com qualquer uma; quem só envia abre o formulário.
        { id: 28, title: 'Notificações', icon: 'mdi-bullhorn-outline', name: podeVerAvisos(this.$user) ? 'construtoraAvisosIndex' : 'construtoraAvisosCreate', permission_name: podeVerAvisos(this.$user) ? 'avisos-visualizar' : 'avisos-enviar', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 24, title: 'Configurações', icon: 'mdi-cog', name: 'construtoraConfiguracoesIndex', permission_name: 'configuration-list', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 25, title: 'Perfil', icon: 'mdi-account-circle-outline', name: 'construtoraPerfil', permission_name: '', show: [true, 'true', 'TRUE'].includes(this.$user.is_construtora) },

        { id: 7, title: 'Chamados', icon: 'mdi-headset', name: 'assistenciaTecnicaGestaoPainel', permission_name: 'garantia-manager', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 8, title: 'Assistência Técnica', icon: 'mdi-wrench-outline', name: 'assistenciaTecnicaIndex', permission_name: 'chamado-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 9, title: 'Manutenções', icon: 'mdi-calendar-check-outline', name: 'manutencaoPreventivaIndex', permission_name: 'manutencao-usuario-view', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 29, title: 'Notificações', icon: 'mdi-bell-outline', name: 'notificacoesIndex', permission_name: '', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 10, title: 'Perfil', icon: 'mdi-account-circle-outline', name: 'perfil', permission_name: '', show: ![true, 'true', 'TRUE'].includes(this.$user.is_construtora) },
        { id: 11, title: 'Sair', icon: 'mdi-logout-variant', name: 'logout', permission_name: '', show: true },
      ],
    };
  },

  watch: {
    mini(value) {
      localStorage.setItem('navigationDrawerMini', value);
      document.documentElement.style.setProperty('--nav-width', value ? '72px' : '292px');
    },
    colorPrimary(newValue) {
      document.documentElement.style.setProperty('--color-primary', newValue);
      document.documentElement.style.setProperty('--color-on-primary', this.getContrastColor(newValue));
    },
  },

  computed: {
    itemsServices() {
      return this.itemsB.filter((item) => !['perfil', 'construtoraPerfil', 'logout'].includes(item.name));
    },
    itemsAccount() {
      return this.itemsB.filter((item) => ['perfil', 'construtoraPerfil', 'logout'].includes(item.name));
    },
  },

  methods: {
    getContrastColor,

    isNavActive(item) {
      const name = this.$route.name;
      if (item.name === 'databook') {
        return ['databook', 'condominoDatabookUuid', 'databookSumarioItens'].includes(name);
      }
      if (item.name === 'assistenciaTecnicaIndex') {
        return [
          'assistenciaTecnicaIndex',
          'assistenciaTecnicaCreate',
          'assistenciaTecnicaShow',
          'assistenciaTecnicaUpdate',
          'assistenciaTecnicaAvaliacao',
        ].includes(name);
      }
      if (item.name === 'manutencaoPreventivaIndex') {
        return [
          'manutencaoPreventivaIndex',
          'manutencaoPreventivaShow',
          'manutencaoPreventivaFornecedorShow',
          'manutencaoPreventivaFornecedorCreate',
          'manutencaoPreventivaFornecedorEdit',
        ].includes(name);
      }
      if (['construtoraAvisosIndex', 'construtoraAvisosCreate'].includes(item.name) && item.id === 28) {
        return ['construtoraAvisosIndex', 'construtoraAvisosCreate', 'construtoraAvisosShow'].includes(name);
      }
      if (item.name === 'construtoraDatabooks') {
        return ['construtoraDatabooks', 'construtoraDatabookUuid', 'construtoraDatabookSumarioItens'].includes(name);
      }
      return name === item.name;
    },
  },

  created() {
    const miniValue = localStorage.getItem('navigationDrawerMini') === 'true';
    const corPrimaria = localStorage.getItem('COR_SISTEMA');
    const defaultColor = '#FBDC04';
    const resolvedColor = [null, undefined, '', 'null', 'undefined', 'false', false, 0, '0'].includes(corPrimaria)
      ? defaultColor
      : corPrimaria;
    this.mini = miniValue;
    if (![true, 'true', 'TRUE'].includes(this.$user.is_construtora)) avisosStore.atualizar();
    this.colorPrimary = resolvedColor;

    document.documentElement.style.setProperty('--color-primary', resolvedColor);
    document.documentElement.style.setProperty('--nav-width', miniValue ? '72px' : '292px');
  },
};
</script>

<style lang="scss" scoped>
.nav-shell {
  width: 292px;
  min-width: 292px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.72);
  border-right: 1px solid rgba(226, 232, 240, 0.9);
  backdrop-filter: blur(18px);
  box-shadow: 14px 0 40px -34px rgba(15, 23, 42, 0.35);
  z-index: 20;
  overflow: visible;
}

.nav-mesh {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(at 20% 30%, rgba(245, 158, 11, 0.08) 0px, transparent 55%),
    radial-gradient(at 80% 20%, rgba(251, 191, 36, 0.06) 0px, transparent 55%),
    radial-gradient(at 50% 80%, rgba(249, 115, 22, 0.05) 0px, transparent 55%),
    radial-gradient(at 90% 70%, rgba(250, 204, 21, 0.04) 0px, transparent 55%);
  pointer-events: none;
}

.nav-shell > * {
  position: relative;
  z-index: 1;
}

.nav-logo {
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
}

.nav-logo-img {
  width: 120px !important;
  max-height: 44px !important;
}

.nav-content {
  flex: 1;
  overflow-y: auto;
  padding: 14px 12px 18px;
}

.nav-section {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9CA3AF;
  margin: 10px 12px 8px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  text-decoration: none;
  font-size: 0.92rem;
  font-weight: 600;
  color: #475569;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.nav-item .v-icon {
  color: #94A3B8;
}

.nav-item:hover {
  background: rgba(var(--color-primary-rgb, 252,207,50), 0.08);
  border-color: rgba(var(--color-primary-rgb, 252,207,50), 0.2);
  color: #111827;
}

.nav-item:hover .v-icon {
  color: var(--color-primary);
}

.nav-item-active {
  background: rgba(var(--color-primary-rgb, 252,207,50), 0.12);
  border-color: rgba(var(--color-primary-rgb, 252,207,50), 0.22);
  box-shadow: 0 12px 24px -18px rgba(var(--color-primary-rgb, 252,207,50), 0.45);
  color: #111827;
  font-weight: 700;
}

.nav-item-active .v-icon {
  color: var(--color-primary);
}

.nav-icon {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-text {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px 16px;
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}

.nav-user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(245, 158, 11, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nav-user-name {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
}

.nav-user-email {
  margin: 2px 0 0;
  font-size: 0.75rem;
  color: #94A3B8;
}

.nav-toggle {
  position: absolute;
  right: -16px;
  top: 80px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(226, 232, 240, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px -14px rgba(15, 23, 42, 0.5);
  z-index: 999;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.nav-toggle .v-icon {
  color: #94A3B8;
}

.nav-toggle:hover {
  background: rgba(var(--color-primary-rgb, 252,207,50), 0.12);
  border-color: rgba(var(--color-primary-rgb, 252,207,50), 0.35);
  box-shadow: 0 12px 22px -14px rgba(var(--color-primary-rgb, 252,207,50), 0.55);
}

.nav-toggle:hover .v-icon {
  color: var(--color-primary);
}

.nav-collapsed {
  width: 72px;
  min-width: 72px;
}

.nav-collapsed .nav-logo-img {
  width: 44px !important;
}

.nav-collapsed .nav-content {
  padding-left: 10px;
  padding-right: 10px;
}

.nav-collapsed .nav-item {
  justify-content: center;
  padding: 10px 8px;
}

.nav-collapsed .nav-user {
  justify-content: center;
}

@media (max-width: 768px) {
  .nav-shell {
    display: none;
  }
}
</style>
